import PaymentMethodOption, { Variant } from './PaymentMethodOption';
import { PaymentMethod as PaymentMethods } from '../../../services/exports/Constants';
import CardPaymentMethod from './CardPaymentMethod';
import PaypalPaymentMethod from './PaypalPaymentMethod';
import CashPaymentMethod from './CashPaymentMethod';
import TaxpayerDocumentPaymentMethod from './TaxpayerDocumentPaymentMethod';

export interface PaymentMethodProps {
  id: PaymentMethods;
  name: string;
  extra: any;
  isSelected: boolean;
  isDisabled: boolean;
  onClick: () => any;
  content?: any;
  children?: any;
  isLastItem: boolean;
  className?: string;
  /** How the row is drawn; the gateway screens pass the look of the list they sit in. */
  variant?: null | Variant;
}

export default function PaymentMethod(props: PaymentMethodProps) {
  const { id } = props;

  const render = () =>
    ({
      [PaymentMethods.Cash]: <CashPaymentMethod {...props} />,
      [PaymentMethods.Card]: <CardPaymentMethod {...props} />,
      [PaymentMethods.Paypal]: <PaypalPaymentMethod {...props} />,
      [PaymentMethods.Pix]: <TaxpayerDocumentPaymentMethod {...props} />,
      [PaymentMethods.Nupay]: <TaxpayerDocumentPaymentMethod {...props} />,
    })[id] ?? <PaymentMethodOption {...props} />;

  return render();
}
